import React from 'react';
import { Switch } from '@headlessui/react';

interface ToggleFieldProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const ToggleField: React.FC<ToggleFieldProps> = ({
  label,
  description,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <Switch.Group as="div" className="flex items-start justify-between gap-4">
      <span className="min-w-0 flex-1 pt-0.5">
        <Switch.Label
          className={`block text-sm font-medium cursor-pointer ${
            disabled ? 'text-gray-400' : 'text-gray-900'
          }`}
        >
          {label}
        </Switch.Label>
        {description ? (
          <Switch.Description className="mt-0.5 block text-xs font-normal text-gray-500">
            {description}
          </Switch.Description>
        ) : null}
      </span>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${
          checked ? 'bg-blue-600' : 'bg-gray-200'
        } relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50`}
      >
        <span
          className={`${
            checked ? 'translate-x-6' : 'translate-x-1'
          } inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform`}
        />
      </Switch>
    </Switch.Group>
  );
};
